import { useNavigate } from 'react-router-dom';
import { FiTrash2 } from 'react-icons/fi';
import { IoChevronForward } from 'react-icons/io5';
import PlatformBadge from '../PlatformBadge/PlatformBadge';
import RefreshButton from '../RefreshButton/RefreshButton';
import './AccountCard.css';

const AccountCard = ({ account, linkedPlatforms, onDelete, onRefreshed }) => {
  const navigate = useNavigate();

  return (
    <div className="account-card" onClick={() => navigate(`/accounts/${account.id}`)}>
      <div className="account-card-header">
        <div className="account-card-text">
          <h3 className="account-card-title">{account.name}</h3>
          {account.description && (
            <p className="account-card-description">{account.description}</p>
          )}
        </div>
        <div className="account-card-chevron">
          <IoChevronForward />
        </div>
      </div>

      <div className="account-card-platforms">
        {linkedPlatforms.length > 0 ? (
          linkedPlatforms.map((p) => <PlatformBadge key={p} platform={p} size="sm" />)
        ) : (
          <span className="account-card-empty-platforms">No platforms linked yet</span>
        )}
      </div>

      <div className="account-card-actions" onClick={(e) => e.stopPropagation()}>
        <RefreshButton
          level="account"
          id={account.id}
          onRefreshed={onRefreshed}
          variant="ghost"
          label="Refresh"
        />
        <button
          className="account-card-delete"
          onClick={() => onDelete(account)}
          title="Delete account"
        >
          <FiTrash2 />
        </button>
      </div>
    </div>
  );
};

export default AccountCard;
